function About(){
    return (
      <section id="about">
        <h1 className="lfh1">About Us</h1>
        <p className="about-desc">
        In a large college environment, losing personal items such as bags, mobile phones, ID cards, 
        or any other belongings is a common issue. The process of recovering lost items can be tedious and 
        time-consuming, often requiring individuals to search multiple locations or ask numerous people if 
        they've seen their missing property. On the other hand, those who find lost items face difficulties in locating the rightful owner to return the found objects
        The platform will allow users to register, create accounts, and log in to upload details and images of lost or found items, including information such as the location where the item was lost or found, the time, and the contact details of the person who found the item. Users who have lost items can browse the website to see if their belongings have been found by others. This system enhances the efficiency of recovering lost items 
        and provides a reliable and straightforward method for communication between finders and owners. 
        </p>
        <footer>
            <p>Copyright &copy; 2024</p>
            <p>Designed and Built by <a href="https://www.linkedin.com/in/tanvik-reddy-07b589290/">K Tanvik Reddy</a></p>
        </footer>
      </section>
      
    );
}
export default About;